import { render, staticRenderFns } from "./CourseV2.vue?vue&type=template&id=6bd2f59a"
import script from "./CourseV2.vue?vue&type=script&lang=js"
export * from "./CourseV2.vue?vue&type=script&lang=js"
import style0 from "./CourseV2.vue?vue&type=style&index=0&id=6bd2f59a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports